// import { logUtil } from 'packages/src'
import updateDataWorkoutUtil from '../../../../../modules/workout/model/utils/update-data'
import setReduxReducer from '../../../../redux/reducers/set'

//

// function deleteReplacedWorkoutAfterLog (state, instance) {
//   const originalWorkoutId = getValueReduxUtil(
//     instance,
//     WORKOUT_KEY.REMOTE_REPLACED_ORIGINAL_WORKOUT_ID
//   )
//   if (!originalWorkoutId) {
//     return state
//   }
//
//   const id = getIdReduxUtil(instance)
//   logUtil('').info(`replacing ${originalWorkoutId} with ${id}`)
//   const oldInstance = getObjectUtil(
//     state,
//     getPathFromDomainPathReduxUtil(
//       WORKOUTS_DOMAIN,
//       originalWorkoutId
//     )
//   )
//
//   const planId = getPlanIdWorkoutUtil(instance)
//   if (planId) {
//     const plan = getByIdPlanSelector(planId)(state)
//     if (plan) {
//       const workouts = (
//         getAllWorkoutsPlanSelector(plan)(state)
//       ).map(workout => {
//         if (getIdReduxUtil(oldInstance) === getIdReduxUtil(workout)) {
//           logUtil('').info(`replacing ${originalWorkoutId} with ${id}, plan
// ${planId}`) return instance } return workout }) if (workouts.length) { state
// = setUtil( state, getPathReduxUtil(plan), updateReduxUtil(plan, {
// [PLAN_KEY.WORKOUTS]: workouts.map(createPointerReduxUtil) }) ) } } }  state
// = deleteInstanceFromDomainReduxUtil({ instance: oldInstance, domainListPath:
// getDomainListPathWorkoutUtil( instance, state ), state })  return
// deleteInstanceReduxUtil(state, oldInstance) }

function updateData (instance, state) {
  const newState = updateDataWorkoutUtil({
    state,
    workout: instance
  })
  return setReduxReducer(state, {
    payload: {
      value: newState
    }
  })
}

function afterCreateWorkoutHook (instance, state) {
  state = updateData(instance, state)
  // if (
  //   getValueReduxUtil(
  //     instance,
  //     WORKOUT_KEY.REMOTE_REPLACED_ORIGINAL_WORKOUT_ID
  //   )
  // ) {
  //   state = deleteReplacedWorkoutAfterLog(state, instance)
  // }
  // if (!isLoggedWorkoutUtil(instance)) {
  //   return state
  // }
  // state = addWorkoutLogToActivityDomain(state, instance)
  return state
}

export { afterCreateWorkoutHook }
